import SearchableSelect from '../../../SearchableSelect';
import { generateReference } from '../../../service/utils/referenceGenerator';

const OrderSelector = ({ orders, value, onChange, error }) => {
  // Formater les options pour afficher la REF cryptée
  const formatOptions = (options) => {
    return options.map(order => ({
      ...order,
      displayLabel: `${order.securityName} (REF: ${generateReference(order.id)})`,
      encryptedRef: generateReference(order.id) // Stocker la ref cryptée
    }));
  };

  // Formater l'option sélectionnée pour l'affichage
  const getDisplayValue = (selectedValue) => {
    if (!selectedValue) return "";
    const selectedOrder = orders.find(order => order.id === parseInt(selectedValue));
    return selectedOrder 
      ? `${selectedOrder.securityName} (REF: ${generateReference(selectedOrder.id)})` 
      : "";
  };

  const formattedOrders = formatOptions(orders);

  return (
    <div className="mb-3">
      <label htmlFor="order" className="form-label fw-semibold">
        Ordre <span className="text-danger">*</span>
      </label>
      <SearchableSelect
        options={formattedOrders}
        value={value}
        onChange={onChange}
        labelKey="displayLabel"
        valueKey="id" // On garde l'ID réel comme valeur, mais l'affichage est crypté
        searchKeys={["securityName", "encryptedRef"]} // Recherche par nom et REF cryptée
        getDisplayValue={getDisplayValue}
        placeholder="Rechercher un ordre par titre ou par REF..."
        className={`form-select ${error ? "is-invalid" : ""}`}
      /> 
      {error && <div className="invalid-feedback d-block">{error}</div>}
      <div className="form-text">
        Sélectionnez l'ordre sur lequel effectuer la transaction
      </div>
    </div>
  );
};

export default OrderSelector;